import { createContext } from 'react';

import type {
  HealthCategoryId,
  IntakeStatusBaseSteps,
  IntakeStatusCustomSteps,
  HealthCategoryConsultationStatus,
} from '@shared/patient-intake-status';

import type { PatientProviderValue } from '../../../components/patient-management/PatientPage/PatientProvider.jsx';

type PatientIntakeStatusContextType = {
  patientId: string;
  isLoading: boolean;
  error: Error | null;
  isHealthcareProvider: boolean;
  baseSteps: IntakeStatusBaseSteps | null;
  healthCategories: HealthCategoryConsultationStatus | null;
  customSteps: IntakeStatusCustomSteps | null;
  activeHealthCategoryId: HealthCategoryId | null;
  activeHealthCategoryIds: HealthCategoryId[] | null;
  setActiveHealthCategoryId: React.Dispatch<React.SetStateAction<HealthCategoryId | null>>;
  patientPageModalActions: PatientProviderValue['actions'] | null;
};

export const PatientIntakeStatusContext = createContext<PatientIntakeStatusContextType | null>(null);
